var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.81 13.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_06_Delete",
    "data-name": "06 Delete",
    transform: "translate(0.153 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M439.008,498.626a.257.257,0,0,0-.192-.086h-7.35a.255.255,0,0,0-.192.086.258.258,0,0,0-.063.2l.8,6.534a1.416,1.416,0,0,0,1.405,1.249h3.44a1.414,1.414,0,0,0,1.4-1.247l.8-6.537A.254.254,0,0,0,439.008,498.626Zm-.5.554-.754,6.122a.9.9,0,0,1-.9.8h-3.44a.9.9,0,0,1-.9-.8l-.754-6.121-.016-.127h6.771Z",
    transform: "translate(-430.573 -493.692)",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M424.374,447.381a.313.313,0,0,1-.155-.041.318.318,0,0,1-.148-.189l-.093-.338a1.384,1.384,0,0,1,.969-1.7l1.344-.368-.055-.2a.983.983,0,0,1,.687-1.205l1.1-.3a.967.967,0,0,1,.259-.035.983.983,0,0,1,.946.722l.055.2,1.344-.368a1.37,1.37,0,0,1,.366-.05,1.389,1.389,0,0,1,1.336,1.019l.093.338a.313.313,0,0,1-.03.237.308.308,0,0,1-.189.147l-7.749,2.125A.267.267,0,0,1,424.374,447.381ZM431,444.13a.75.75,0,0,0-.2.027l-5.682,1.558a.759.759,0,0,0-.536.912l.014.057,7.148-1.96-.017-.056A.767.767,0,0,0,431,444.13Zm-2.712-.5a.376.376,0,0,0-.093.012l-1.1.3a.354.354,0,0,0-.248.436l.055.2,1.785-.49-.055-.2A.357.357,0,0,0,428.286,443.626Z",
    transform: "translate(-423.929 -443)",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M473.358,518.942a.277.277,0,0,0,.278-.278v-4.8a.278.278,0,1,0-.555,0v4.8A.277.277,0,0,0,473.358,518.942Z",
    transform: "translate(-468.79 -507.428)",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M452.006,518.943h.022a.278.278,0,0,0,.255-.3l-.379-4.8a.278.278,0,0,0-.553.044l.379,4.8A.278.278,0,0,0,452.006,518.943Z",
    transform: "translate(-448.956 -507.429)",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M490.707,518.941h.022a.278.278,0,0,0,.277-.256l.379-4.8a.278.278,0,1,0-.553-.044l-.379,4.8A.278.278,0,0,0,490.707,518.941Z",
    transform: "translate(-484.644 -507.428)",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5dfb089847f04a22ca67ea68417398f6.svg";
export { ForwardRef as ReactComponent };